const { pathOr } = require('ramda');

module.exports = pathOr([], ['value']);
